import { useCallback, useEffect, useState } from 'react';
import { ToastType, showToastMessage } from '../utils/ToastOptionCommon';
import { IStateCity } from '../constants/interface/IStateCity';

const apiUrl = process.env.REACT_APP_API_URL;

interface IProps {
  stateCode: string;
}

export const useStateCity = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [stateLoading, setStateLoading] = useState(false);
  const [states, setStates] = useState<Array<IStateCity>>([]);
  const [cities, setCitis] = useState<Array<IStateCity>>([]);

  const getStates = useCallback(async () => {
    setStateLoading(true);
    const res = await fetch(`${apiUrl}/country/IN`)
      .then((r) => r.json())
      .then((r) => r)
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setStateLoading(false);
      });
    if (res?.error) {
      showToastMessage('Failed to get states', ToastType.Error);
    } else {
      setStates(res);
    }
  }, []);

  const getCities = useCallback(async () => {
    if (props.stateCode) {
      setLoading(true);
      const res = await fetch(`${apiUrl}/country/IN/${props.stateCode}`)
        .then((r) => r.json())
        .then((r) => r)
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
      if (res?.error) {
        showToastMessage('Failed to get cities', ToastType.Error);
      } else {
        setCitis(res);
      }
    }
  }, [props.stateCode]);

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
    if (props.stateCode) {
      getCities();
    }
  }, [props.stateCode]);

  return { loading, stateLoading, states, cities };
};
